/**
 * WHYSHIFT Related Objects — lazy-load Shopify product recommendations.
 */
function initWhyshiftRelatedObjects(section) {
  if (section.dataset.recommendationsPerformed === 'true') return;
  if (section.dataset.whyshiftRelatedInit === 'true') return;

  const productId = section.dataset.productId;
  const sectionId = section.dataset.sectionId;
  const baseUrl = section.dataset.url;

  if (!productId || !sectionId || !baseUrl) return;

  section.dataset.whyshiftRelatedInit = 'true';

  const runLoad = () => loadRecommendations(section, { productId, sectionId, baseUrl });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, intersectionObserver) => {
        if (!entries[0]?.isIntersecting) return;

        intersectionObserver.disconnect();
        runLoad();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    observer.observe(section);

    // Hidden sections never intersect — fetch immediately as fallback.
    if (section.hidden || section.offsetParent === null) {
      observer.disconnect();
      runLoad();
    }
  } else {
    runLoad();
  }
}

async function loadRecommendations(section, { productId, sectionId, baseUrl }) {
  const url = `${baseUrl}&product_id=${productId}&section_id=${sectionId}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      section.hidden = true;
      return;
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('[data-whyshift-related-content]');
    const currentContent = section.querySelector('[data-whyshift-related-content]');

    if (!newContent || !currentContent) {
      section.hidden = true;
      return;
    }

    const hasSlides = newContent.querySelector('.whyshift-carousel__slide');
    const hasLiquidError = html.includes('Liquid error');

    if (!hasSlides || hasLiquidError) {
      section.hidden = true;
      return;
    }

    currentContent.innerHTML = newContent.innerHTML;
    section.hidden = false;
    section.classList.remove('whyshift-related-objects--pending');
    section.dataset.recommendationsPerformed = 'true';
  } catch (error) {
    console.error('WHYSHIFT related objects:', error);
    section.hidden = true;
  }
}

function initAllWhyshiftRelatedObjects() {
  document.querySelectorAll('.whyshift-related-objects').forEach(initWhyshiftRelatedObjects);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllWhyshiftRelatedObjects);
} else {
  initAllWhyshiftRelatedObjects();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.whyshift-related-objects') || event.target.closest('.whyshift-related-objects');
  if (section) initWhyshiftRelatedObjects(section);
});
